import React, { useEffect, useState } from 'react';
import { Layout } from '../../components/Layout';
import Loader from '../../components/Layout/Loader';
import Notification from '../../services/Notification/Notification';
import CIcon from '@coreui/icons-react';
import { cilInbox } from '@coreui/icons';
import Logger from '../../services/Logger/Logger';
import { Language } from '../../language/English';
import { FeedbackService } from './Api/FeedbackService';
import { FeedbackPojo } from './Api/FeedbackPojo';
import FeedbackList from './FeedbackList';
import FeedbackCard from './FeedbackCard';

const Feedback = () => {
    const [feedbacks, setFeedbacks] = useState<FeedbackPojo[]>([]);
    const [unreadOnly, setUnreadOnly] = useState<boolean>(false);
    const [showLoader, setShowLoader] = useState<boolean>(true);

    const notification = new Notification();
    const logger = new Logger();
    const feedbackService = new FeedbackService();

    const fetchFeedbacks = async () => {
        try {
            const response = await feedbackService.getAll();
            if (response.isSuccess) {
                setFeedbacks(response.feedbacks);
            } else {
                notification.error(Language.SOMETHING_IS_WRONG);
            }
        } catch (e) {
            notification.error(Language.SOMETHING_IS_WRONG);
            logger.error(e);
        } finally {
            setShowLoader(false);
        }
    };

    useEffect(() => {
        fetchFeedbacks();
    }, []);

    const filteredFeedbacks = unreadOnly
        ? feedbacks.filter((feedback) => !feedback.markAsRead)
        : feedbacks;

    return (
        <Layout>
            {showLoader && <Loader />}
            <FeedbackList
                filterControls={
                    feedbacks.length > 0 ? (
                        <div className="d-flex align-items-center bg-white px-3 py-2 rounded-pill shadow-sm border feedback-filter-container">
                            <div className="form-check form-switch mb-0 d-flex align-items-center" style={{ cursor: 'pointer' }}>
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    role="switch"
                                    id="unreadOnlyFilter"
                                    checked={unreadOnly}
                                    onChange={(e) => setUnreadOnly(e.target.checked)}
                                    style={{ cursor: 'pointer' }}
                                />
                                <label className="form-check-label fw-semibold text-dark ms-2 mb-0" htmlFor="unreadOnlyFilter" style={{ cursor: 'pointer' }}>
                                    {Language.SHOW_UNREAD_ONLY || 'Show Unread Only'}
                                </label>
                            </div>
                        </div>
                    ) : undefined
                }
            >
                {filteredFeedbacks.length > 0 ? (
                    filteredFeedbacks.map((feedback) => (
                        <FeedbackCard 
                            key={feedback.feedbackId} 
                            feedback={feedback} 
                            onActionSuccess={fetchFeedbacks} 
                            notification={notification}
                            feedbackService={feedbackService}
                            logger={logger}
                        />
                    ))
                ) : (
                    !showLoader && (
                        <div className="col-12 text-center py-5">
                            <div className="text-muted">
                                <CIcon icon={cilInbox} size="3xl" className="mb-3 opacity-25" />
                                <p>{Language.NO_RECORD_FOUND || 'No feedbacks found.'}</p>
                            </div>
                        </div>
                    )
                )}
            </FeedbackList>
        </Layout>
    );
};

export default Feedback;
